<script setup lang="ts">
defineProps<{
    variant?: 'ok' | 'pend' | 'no' | 'draft' | 'off' | 'paid' | 'free' | 'partial' | 'arch'
    label?: string
}>()

const variantClasses: Record<string, string> = {
    ok: 'bg-green-l text-green-text',
    pend: 'bg-yellow-l text-yellow-text',
    no: 'bg-red-l text-red-text',
    draft: 'bg-gray-100 text-gray-600 border border-gray-200',
    off: 'bg-gray-200 text-gray-600',
    paid: 'bg-green-l text-green-text',
    free: 'bg-blue-l text-blue-text',
    partial: 'bg-yellow-l text-yellow-text',
    arch: 'bg-gray-100 text-gray-500'
}

const dotClasses: Record<string, string> = {
    ok: 'bg-green',
    pend: 'bg-yellow',
    no: 'bg-red',
    draft: 'bg-gray-400',
    off: 'bg-gray-500',
    paid: 'bg-green',
    free: 'bg-blue',
    partial: 'bg-yellow',
    arch: 'bg-gray-400'
}
</script>

<template>
    <span
        :class="[
            'inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold whitespace-nowrap',
            variantClasses[variant ?? 'draft']
        ]"
    >
        <span :class="['w-1.5 h-1.5 rounded-full', dotClasses[variant ?? 'draft']]" />
        <span>{{ label }}<slot /></span>
    </span>
</template>
